import axios from 'axios'
import router from '@/router'
import useAuth from '@/utils/useAuth'

const { auth, removeTokens } = useAuth()
const baseURL =
  process.env.NODE_ENV === 'development'
    ? '/'
    : process.env.VUE_APP_BASE_API || '/'

const service = axios.create({
  baseURL,
  timeout: 60 * 1000, // 1 минута
  withCredentials: true,
})

service.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    const originalRequest = error.config
    // 401 - время жизни токена закончилось, нужно обновить
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      error.response?.data?.code === 'access-denied' &&
      error.config?.url !== '/api/oauth/token/cookie'
    ) {
      try {
        originalRequest._retry = true
        await auth({
          grant_type: 'refresh_token',
        })

        return service(originalRequest)
      } catch (error) {
        console.error(error)
        removeTokens()
        router.push({ name: 'Auth' })
        return Promise.reject(error)
      }
    }

    return Promise.reject(error)
  }
)

export default service
